import { translateLabel } from "@/i18n/messages";
export const PENDING_AUTH_ACTION = {
  ADD_FAVORITE: "favorite:add",
  START_DESTINATION_REVIEW: "destination-review:start",
  SET_TRAIL_RATING: "trail-rating:set",
  START_MEDIA_CONTRIBUTION: "media-contribution:start",
};

export const normalizeAuthReturnTo = (value) => {
  if (typeof value !== "string") return "/";
  if (!value.startsWith("/") || value.startsWith("//")) return "/";
  return value;
};

export const createFavoritePendingAction = ({ itemId, itemType, returnTo }) => ({
  type: PENDING_AUTH_ACTION.ADD_FAVORITE,
  itemId,
  itemType,
  returnTo: normalizeAuthReturnTo(returnTo),
  label: itemType === "trail" ? "save this trail" : "save this park",
});

export const createDestinationReviewPendingAction = ({ destinationId, returnTo }) => ({
  type: PENDING_AUTH_ACTION.START_DESTINATION_REVIEW,
  destinationId,
  returnTo: normalizeAuthReturnTo(returnTo),
  label: "write a review",
});

export const createTrailRatingPendingAction = ({ trailId, rating, returnTo }) => ({
  type: PENDING_AUTH_ACTION.SET_TRAIL_RATING,
  trailId,
  rating,
  returnTo: normalizeAuthReturnTo(returnTo),
  label: "rate this trail",
});

export const createMediaContributionPendingAction = ({ destinationId, trailId, mode, returnTo }) => ({
  type: PENDING_AUTH_ACTION.START_MEDIA_CONTRIBUTION,
  destinationId,
  trailId: trailId || null,
  mode,
  returnTo: normalizeAuthReturnTo(returnTo),
  label: mode === "video" ? "add a YouTube video" : "upload a photo",
});

export const pendingAuthReducer = (state, event) => {
  switch (event?.type) {
    case "REQUEST":
      return event.action ?? null;
    case "CANCEL":
    case "LOGOUT":
    case "RESUME_STARTED":
      return null;
    case "AUTH_FAILED":
      // Keep the intent so a mistyped password does not make the rider lose context.
      return state;
    default:
      return state;
  }
};

export const pendingAuthPrompt = (action, mode = "login") => {
  if (!action) return null;
  const verb = translateLabel(mode === "register" ? "Create an account to" : "Sign in to");
  const actionLabel = translateLabel(action.label || "continue");
  return `${verb} ${actionLabel}. ${translateLabel("We’ll return you where you left off.")}`;
};

export const resumePendingAuthAction = async (action, handlers) => {
  if (!action) return { resumed: false, returnTo: "/" };

  if (action.type === PENDING_AUTH_ACTION.ADD_FAVORITE) {
    if (typeof handlers?.addFavorite !== "function") {
      throw new Error("Missing addFavorite pending-auth handler");
    }
    await handlers.addFavorite(action.itemId, action.itemType);
    return {
      resumed: true,
      returnTo: normalizeAuthReturnTo(action.returnTo),
      action,
    };
  }

  if (action.type === PENDING_AUTH_ACTION.START_DESTINATION_REVIEW) {
    return {
      resumed: true,
      returnTo: normalizeAuthReturnTo(action.returnTo),
      action,
    };
  }

  if (action.type === PENDING_AUTH_ACTION.START_MEDIA_CONTRIBUTION) {
    return {
      resumed: true,
      returnTo: normalizeAuthReturnTo(action.returnTo),
      action,
    };
  }

  if (action.type === PENDING_AUTH_ACTION.SET_TRAIL_RATING) {
    if (typeof handlers?.setTrailRating !== "function") {
      throw new Error("Missing setTrailRating pending-auth handler");
    }
    await handlers.setTrailRating(action.trailId, action.rating);
    return {
      resumed: true,
      returnTo: normalizeAuthReturnTo(action.returnTo),
      action,
    };
  }

  throw new Error(`Unsupported pending auth action: ${action.type}`);
};
